var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOneOnOne = function SvgOneOnOne(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.111,
    cy: 3.111,
    r: 2.361,
    stroke: "#2D9CDB",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.889,
    cy: 10.889,
    r: 2.361,
    stroke: "#2D9CDB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D9CDB",
    fillRule: "evenodd",
    d: "M1.556 7.098q.482.188 1.014.257a4.445 4.445 0 0 0 4.075 4.076q.069.53.257 1.013a5.445 5.445 0 0 1-5.346-5.346m10.888-.196a5.445 5.445 0 0 0-5.346-5.346q.188.482.257 1.014a4.445 4.445 0 0 1 4.076 4.075 4.3 4.3 0 0 1 1.013.257",
    clipRule: "evenodd"
  })));
};
export default SvgOneOnOne;